export default __webpack_public_path__ + "static/media/Blurred.aac8fe38.png";